import { useSearchParams } from "react-router-dom";

export const READ_ONLY_CALENDAR_PARAM = "readonly";

/**
 * Read-only mode is driven by the URL (`?readonly=true`) rather than store state so that
 * a page refresh cannot silently restore edit capabilities. Entered via the admin sidebar's
 * "Admin Calendar" button; exited via the calendar header's exit button.
 */
function useIsReadOnlyCalendar(): boolean {
  const [searchParams] = useSearchParams();
  return searchParams.get(READ_ONLY_CALENDAR_PARAM) === "true";
}

export default useIsReadOnlyCalendar;
